import "./Products.css";
import {
  FaSchool,
  FaHospital,
  FaFileInvoiceDollar,
  FaBuilding,
  FaUsersCog,
  FaBoxes,
  FaGavel,
  FaGlobe,
  FaMobileAlt
} from "react-icons/fa";

const products = [
  {
    icon: <FaSchool />,
    title: "School ERP",
    desc: "Complete school management solution including admissions, fees, attendance, exams and reports."
  },
  {
    icon: <FaHospital />,
    title: "Hospital Management",
    desc: "Manage patients, doctors, appointments, billing and pharmacy efficiently."
  },
  {
    icon: <FaFileInvoiceDollar />,
    title: "GST Billing Software",
    desc: "Professional GST billing software with invoice printing and inventory support."
  },
  {
    icon: <FaBuilding />,
    title: "College ERP",
    desc: "Student management, attendance, examination, fees and administration."
  },
  {
    icon: <FaUsersCog />,
    title: "HR Management",
    desc: "Employee attendance, payroll, leave management and HR reports."
  },
  {
    icon: <FaBoxes />,
    title: "Inventory System",
    desc: "Stock management with purchase, sales, suppliers and reports."
  },
  {
    icon: <FaGavel />,
    title: "RTI Portal",
    desc: "Online RTI application generation and document management system."
  },
  {
    icon: <FaGlobe />,
    title: "Business Website",
    desc: "Modern responsive business websites with SEO and fast performance."
  },
  {
    icon: <FaMobileAlt />,
    title: "Custom Software",
    desc: "Custom software and web applications developed as per your business requirements."
  }
];

function Products() {

  return (

<section className="products" id="products">

<div className="container">

<div className="section-title">

<h2>Our Products</h2>

<p>

Powerful software solutions designed to simplify business operations and improve productivity.

</p>

</div>

<div className="products-grid">

{

products.map((item,index)=>(

<div className="product-card" key={index}>

<div className="product-icon">

{item.icon}

</div>

<h3>

{item.title}

</h3>

<p>

{item.desc}

</p>

<a href="#contact">

Request Demo →

</a>

</div>

))

}

</div>

</div>

</section>

);

}

export default Products;